import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

export interface Message {
  id: string;
  type: string;
  category: string;
  title: string;
  content: string;
  dateSent: Date;
  dateViewed?: Date;
  expires?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  private apiService = inject(ApiService);

  getMessages(updateViewed = false): Observable<Message[]> {
    return this.apiService.get(`api/message/?updateViewed=${updateViewed}`);
  }
}
